
import Config from '../config.json';
import { getStorage, setStorage, removeStorage } from '../storage';

// 직접 fetch 를 쓰는 화면에서 쓰는 인증 헤더 헬퍼.
// (엑셀/CSV 다운로드처럼 응답을 blob 으로 받아야 해서 fetchData 를 못 쓰는 곳들)
export const authHeader = async (): Promise<any> => {
    try {
        const session = await getStorage('Session');
        return session?.token ? { Authorization: `Bearer ${session.token}` } : {};
    } catch (e) {
        return {};
    }
};

// 서버는 토큰 남은 수명이 1시간 이하가 되면 응답에 X-New-Token 헤더로 새 토큰을 동봉한다.
// 그걸 조용히 교체해두면, 센서화면처럼 10초마다 폴링하는 화면은 켜져 있는 한 만료되지 않는다.
const applyNewToken = async (response: any) => {
    try {
        const fresh = response?.headers?.get ? response.headers.get('X-New-Token') : null;
        if (!fresh) return;
        const session = await getStorage('Session');
        if (session) {
            session.token = fresh;
            await setStorage('Session', session);
        }
    } catch (e) {
        // 갱신 실패는 원래 요청에 영향을 주지 않는다
    }
};

// 그래도 만료된 경우(예: 태블릿이 전원이 꺼진 채 2시간을 넘김)
// 자동로그인에 저장된 계정으로 조용히 다시 로그인한다.
// 여러 요청이 동시에 401 을 받아도 로그인은 한 번만 나가도록 묶는다.
let reloginPromise: Promise<string | null> | null = null;
const relogin = async (): Promise<string | null> => {
    if (!reloginPromise) {
        reloginPromise = (async (): Promise<string | null> => {
            try {
                const auto = await getStorage('AutoLogin');
                if (!auto?.id || !auto?.pw) return null;   // 자동로그인 미사용 → 재로그인 불가
                const res = await fetch(`${Config?.APIserver}user/login`, {
                    method: 'POST',
                    headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
                    body: JSON.stringify({ ID: auto.id, PASSWORD: auto.pw }),
                });
                const json = await res.json();
                if (json?.count !== 1 || !json?.result?.token) return null;
                const userInfo = json?.result?.userInfo?.[0];
                await setStorage('Session', {
                    id: userInfo?.ID,
                    role: Number(userInfo?.ADMIN),
                    hospital: json?.result?.hospitalInfo,
                    server: json?.result?.serverVer,
                    token: json?.result?.token,
                    // 수동 로그인(Login.tsx)과 같은 값. 빠지면 '중계기 설정'의
                    // 현재 서버 비교가 자동 재로그인 후 조용히 깨진다.
                    gwIp: json?.result?.gwPublicIp || '',
                });
                return json.result.token;
            } catch (e) {
                return null;
            }
        })();
    }
    const token = await reloginPromise;
    reloginPromise = null;
    return token;
};

// 재로그인도 안 되는 경우에만 로그인 화면으로 돌려보낸다.
let expiredNotified = false;
const sessionExpired = async () => {
    if (expiredNotified) return;
    expiredNotified = true;
    try { await removeStorage('Session'); } catch (e) { }
    try {
        alert('세션이 만료되었습니다. 다시 로그인해 주세요.');
        if (typeof window !== 'undefined') window.location.reload();
    } catch (e) { }
};

export default class Data {

    // 로그인 시 발급받은 토큰을 모든 요청에 붙인다.
    // 이 한 곳만 고치면 Data.fetchData 를 쓰는 화면 전체(143곳)가 함께 적용된다.
    static async fetchData(address: any, params: any, callback: any, cbError: any) {

        const send = (token: any) => {
            const chcheoption: any = {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            };
            if (token) chcheoption['Authorization'] = `Bearer ${token}`;
            return fetch(`${Config?.APIserver}${address}`, {
                method: 'POST',
                headers: chcheoption,
                body: JSON.stringify(params),
            });
        };

        try {
            let token: any = null;
            try {
                const session = await getStorage('Session');
                token = session?.token || null;
            } catch (e) {
                // 저장소를 못 읽어도 요청 자체는 진행한다 (서버가 관용 모드인 동안)
            }

            let response: any = await send(token);

            // 토큰 만료 → 자동로그인 정보로 한 번만 재발급하고 원요청을 재시도한다.
            if (response.status === 401 && address !== 'user/login') {
                const fresh = await relogin();
                if (!fresh) { await sessionExpired(); return; }
                response = await send(fresh);
                if (response.status === 401) { await sessionExpired(); return; }
            }

            await applyNewToken(response);

            const responseJson = await response.json();
            if (callback)
                callback(responseJson.result, responseJson.count);
        } catch (error: any) {
            console.warn('[fetch]', address, error?.message || '');
            if (typeof cbError === 'function') cbError(error);
        }
    };


}
